import styled from 'styled-components';

const NavigationMenuWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  height: 20px;
`;

export default NavigationMenuWrapper;
